var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data[0].values.length > 0)?_c('div',[_c('vue-frappe',{attrs:{"id":"test","type":"line","isNavigable":true,"height":300,"labels":_vm.getLabels(),"colors":['#2759c8'],"dataSets":this.data,"tooltipOptions":{
                formatTooltipY: d => 'GMD ' + _vm.formatPrice(d),
            }}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }